import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import RankTab from "../../../../../components/Rank/RankTab";
import { get } from "../../../../../utils/request";
import "./style.css";
import "../../../../../index.css";
class SubjectRankSubClass extends Component {
  constructor(props) {
    super(props);
    this.state = {
      subclasses: null,
    };
  }
  componentWillMount() {
    this.requestSubclasses();
  }
  render() {
    const { subclasses } = this.state;
    return (
      <div>
        <RankTab subjectActive={true} schoolActive={false}></RankTab>
        {subclasses != null ? (
          <div>
            {subclasses.map((item, index) => {
              return (
                <NavLink
                  key={index}
                  className="subjectRankSubClass_item"
                  to={"/rank/subject/intro/" + item.hashId}
                >
                  <div className="fl">{item.name}</div>
                  <img
                    alt=""
                    className="fr"
                    src={require("../../../../../images/article/more.png")}
                  ></img>
                </NavLink>
              );
            })}
          </div>
        ) : (
          ""
        )}
        <div style={{ height: 47 }}></div>
      </div>
    );
  }
  /**
   * 请求学科大类下学科小类
   */
  requestSubclasses = () => {
    let hashId = this.props.match.params.hashId;
    get("/public/v1/rank/subject/subclass/" + hashId).then((res) => {
      this.setState({
        subclasses: res.data,
      });
    });
  };
}

export default SubjectRankSubClass;



// WEBPACK FOOTER //
// ./src/containers/Rank/SubjectRank/components/SubjectRankSubClass/index.js